<template>
  <app-layout>
    <template v-slot:submenu>
      <sub-menu>
        <router-link :to="{ name: 'ShowSite', params: { id: site_uuid} }" class="btn btn-outline-dark">
          <show-icon name="back" size="sm" class="align-middle"></show-icon>
          {{ t("models.site") }}
        </router-link>

        <router-link v-if="owner_type != 'Site'" :to="routeToObject(owner_type, owner_uuid)" class="btn btn-outline-dark">
          <show-icon :name="owner_type.toLowerCase()" size="sm" class="align-middle"></show-icon>
          {{ t("models." + owner_type.toLowerCase()) }}
        </router-link>

        <button class="btn btn-outline-dark" @click="onNewEmo">
          <show-icon name="new" size="sm" class="align-middle"></show-icon>
          <span class="d-none d-sm-inline">&nbsp;{{ t('new') }}</span>
        </button>        
      </sub-menu>
    </template>

    <template v-slot:default>
      <page-header icon="emo">
        <h4 class="lh-1 m-0">{{ t('models.emo', 2) }}</h4>
        <small>{{ site.name }}</small>
      </page-header>

      <div class="bg-body rounded shadow-sm">
        <ul class="list-group">
          <li v-for="emo in all_emos" :key="emo.uuid" class="list-group-item">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-10 text-start">
                <router-link :to="{ name: 'ShowEmo', params: { id: emo.uuid } }" class="h5">
                  {{ emo.name }}
                </router-link>
                <p>{{ emo.description }}</p>
              </div>
              <div class="col-12-col-em-12 col-md-12 col-lg-2 text-end">
                <router-link v-if="ownerOf(emo)" :to="routeToOwner(emo)" class="btn btn-sm btn-outline-dark m-1" style="min-width: 5rem">
                  {{ t('models.' + emo.owner_type.toLowerCase(), 1) }}
                </router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <NewEmoPopup v-if="showNewEmoPopup" 
                    :site-id="site_uuid"
                    :asset-id="asset_uuid"
                    :location-id="location_uuid"
                    @closeNewEmoPopup="onCloseNewEmoPopup">
      </NewEmoPopup>

    </template>
  </app-layout>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

import NewEmoPopup from '@/views/emos/NewEmoPopup.vue';
import { routeToObject } from '@/common/url_path_helper';

export default {
  name: "EmoIndex",
  setup() {
    const route = useRoute();
    const store = useStore();
    const { t } = useI18n({ useScope: 'global' });

    let asset_uuid, location_uuid, owner_type, owner_uuid;
    const site_uuid = route.query.site_id;
    const site = store.getters.getSite(site_uuid);

    if (route.query.location_id) {
      owner_type = "Location";
      owner_uuid = route.query.location_id;
      location_uuid = route.query.location_id;
    } else if (route.query.asset_id) {
      owner_type = "Asset";
      owner_uuid = route.query.asset_id;
      asset_uuid = route.query.asset_id;
    } else {
      owner_type = "Site";
      owner_uuid = route.query.site_id;
    }

    const all_emos = store.getters.searchEmosBy(route.query);

    return {
      site,
      site_uuid,
      asset_uuid,
      location_uuid,
      owner_type,
      owner_uuid,
      all_emos,
      routeToObject,
      t
    }
  },
  data() {
    return {
      showNewEmoPopup: false
    }
  },
  computed: {
  },
  methods: {
    onNewEmo() {
      this.showNewEmoPopup = true
    },
    onCloseNewEmoPopup() {
      this.showNewEmoPopup = false
    },
    ownerOf(emo) {
      console.log("Inside views/notes/Index.vue ownerOf(): emo ==> ", emo);
      if (emo.owner_uuid) {
        switch (emo.owner_type) {
          case "Location":
            return this.$store.getters.getLocationByUUID(emo.owner_uuid);
          case "Asset":
            return this.$store.getters.getAssetByUUID(emo.owner_uuid);
          case "Site":
            return this.$store.getters.getSite(emo.owner_uuid);
          default:
            return null;
        }
      } else {
        return null;
      }
    },
    routeToOwner(emo) {
      if (emo.owner_type && emo.owner_uuid) {
        return routeToObject(emo.owner_type, emo.owner_uuid);
      } else {
        return null;
      }
    }    
  },
  components: {
    NewEmoPopup
  }
}
</script>